import { render, staticRenderFns } from "./NewCheckbox.vue?vue&type=template&id=a5076d32&scoped=true&"
import script from "./NewCheckbox.vue?vue&type=script&lang=js&"
export * from "./NewCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./NewCheckbox.vue?vue&type=style&index=0&id=a5076d32&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5076d32",
  null
  
)

export default component.exports